/* global I18n */
/* global gon */
import React, { useContext, useEffect, useState } from 'react'
import DismissableNotificationContainer from '../../../containers/publisher/EditHeader/DismissableNotificationContainer'
import { UploadContext } from '../../../contexts/UploadContext'

const i18nOptions = {
  scope: 'turbosquid.products.product_header',
}

const ProductVariantAdvisory = () => {
  const [dismissedProductId, setDismissedProductId] = useState()
  const { variantCandidates = [] } = useContext(UploadContext) || {}
  const productId = variantCandidates[0]

  useEffect(() => {
    if (!productId) setDismissedProductId(undefined)
  }, [productId])

  if (!productId || dismissedProductId === productId) return null

  const productPath = `${gon.turbosquid_products_path}/${productId}/edit`
  const notificationId = `variantCandidateNotifications-${productId}`

  return (
    <div className="col-xs-12 product-variant-advisory">
      <DismissableNotificationContainer
        notificationLevel="warning"
        notificationId={notificationId}
      >
        <div className="variant-advisory-content">
          <span className="variant-advisory-icon" aria-hidden="true">!</span>
          <div className="variant-advisory-copy">
            <p className="notification-message"><strong>{I18n.t('variant_advisory_title', i18nOptions)}</strong></p>
            <p className="notification-message">{I18n.t('variant_advisory_message', i18nOptions)}</p>
          </div>
        </div>
        <div className="variant-advisory-actions">
          <a href={productPath} className="btn variant-advisory-open-product">
            {I18n.t('variant_advisory_open_product', { ...i18nOptions, id: productId })}
          </a>
          <button
            type="button"
            className="btn btn-link variant-advisory-continue"
            onClick={() => setDismissedProductId(productId)}
          >
            {I18n.t('variant_advisory_continue', i18nOptions)}
          </button>
        </div>
      </DismissableNotificationContainer>
    </div>
  )
}

export default ProductVariantAdvisory
